import { defineComponent as _defineComponent } from 'vue'
import ExternalLink from '@/components/svg/external-link.svg?inline';


export default /*#__PURE__*/_defineComponent({
  __name: 'CertificateEducationItem',
  props: {
  title: {
    type: String,
    default: '',
  },
  origin: {
    type: String,
    default: '',
  },
  year: {
    type: Number,
    default: 2020,
  },
  link: {
    type: String,
    default: '',
  },
},
  setup(__props) {



return { __sfc: true,ExternalLink }
}

})